import { render } from "./po_processing.vue?vue&type=template&id=10331d38&scoped=true"
import script from "./po_processing.vue?vue&type=script&lang=js"
export * from "./po_processing.vue?vue&type=script&lang=js"

import "./po_processing.vue?vue&type=style&index=0&id=10331d38&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10331d38"]])

export default __exports__